import UserSearch, { ResultItem as _ResultItem } from "./UserSearch";

export type ResultItem = _ResultItem;
export default UserSearch;
